import Vue from "vue";
import btn from '@/_oad_repo/components/form/btn'
import DropdownMenu from '@innologica/vue-dropdown-menu' //revise and delete?
import FieldSet from '@/_oad_repo/components/form/Field-Set';
import FieldSetText from '@/_oad_repo/components/form/Field-Set-Text';
import FieldText from '@/_oad_repo/components/form/Text';
import FieldDate from '@/_oad_repo/components/form/Date';
import FieldDateTime from '@/_oad_repo/components/form/DateTime';
import FieldSelect from '@/_oad_repo/components/form/Select';
import FieldToggle from '@/_oad_repo/components/form/Toggle';
import FieldTextArea from '@/_oad_repo/components/form/Textarea';
import FieldHidden from '@/_oad_repo/components/form/Hidden';
import FieldEcheck from '@/_oad_repo/components/form/Echeck';
import FieldFile from '@/_oad_repo/components/form/File';
import FieldAddress from '@/_oad_repo/components/form/Address';
import FieldPhone from '@/_oad_repo/components/form/Phone';
import FieldEmail from '@/_oad_repo/components/form/Email';
import FieldNotesList from '@/_oad_repo/components/form/NotesList';
import FieldFilesList from '@/_oad_repo/components/form/FilesList';

Vue.component('dropdown-menu',DropdownMenu)
Vue.component('btn',btn);
Vue.component('f-set', FieldSet)
Vue.component('f-set-text', FieldSetText)
Vue.component('f-text', FieldText)
Vue.component('f-date', FieldDate)
Vue.component('f-datetime', FieldDateTime)
Vue.component('f-select', FieldSelect)
Vue.component('f-toggle', FieldToggle)
Vue.component('f-textarea', FieldTextArea) 
Vue.component('f-hidden', FieldHidden)
Vue.component('f-echeck', FieldEcheck)
Vue.component('f-file', FieldFile)
Vue.component('f-address', FieldAddress)
Vue.component('f-phone', FieldPhone)
Vue.component('f-email', FieldEmail)
Vue.component('f-noteslist', FieldNotesList)
Vue.component('f-fileslist', FieldFilesList)